module.exports = __webpack_public_path__ + "static/ausenLogoBack-01948e1471f6686cbf024e2636c13be3.jpg";